module.exports = __webpack_public_path__ + "static/img/douyin.001e6d3c.png";